// tslint:disable: completed-docs

import { ApiCredentials } from '@vfde-fe/utils';
import { APP, CONTAINER_TRADEIN } from 'Constant';

// Actions
export const CREATE_INITIAL_STATE = `${APP}/${CONTAINER_TRADEIN}/CREATE_INITIAL_STATE`;
export const SET_DEFAULT_STATE = `${APP}/${CONTAINER_TRADEIN}/SET_DEFAULT_STATE`;
export const GET_TRADE_IN_DEVICES_SUCCESS = `${APP}/${CONTAINER_TRADEIN}/GET_TRADE_IN_DEVICES_SUCCESS`;
export const GET_TRADE_IN_DEVICES_FAILED = `${APP}/${CONTAINER_TRADEIN}/GET_TRADE_IN_DEVICES_FAILED`;
export const GET_TRADE_IN_DEVICES = `${APP}/${CONTAINER_TRADEIN}/GET_TRADE_IN_DEVICES`;
export const SHOW_LOADING = `${APP}/${CONTAINER_TRADEIN}/SHOW_LOADING`;
export const TOGGLE_TRADE_IN_SWITCH = `${APP}/${CONTAINER_TRADEIN}/TOGGLE_TRADE_IN_SWITCH`;
export const SET_SUGGEST_FIELD_VALUE = `${APP}/${CONTAINER_TRADEIN}/SET_SUGGEST_FIELD_VALUE`;
export const SELECT_DEVICE = `${APP}/${CONTAINER_TRADEIN}/SELECT_DEVICE`;
export const SET_TRADE_IN_DEVICE = `${APP}/${CONTAINER_TRADEIN}/SET_TRADE_IN_DEVICE`;
export const DELETE_SELECTED_TRADE_IN_DEVICE = `${APP}/${CONTAINER_TRADEIN}/DELETE_SELECTED_TRADE_IN_DEVICE`;
export const SET_DEVICE_NOT_FOUND = `${APP}/${CONTAINER_TRADEIN}/SET_DEVICE_NOT_FOUND`;

export const TRADEIN_API = 'https://apix-test3.dlstradein.link/tmf-api/productCatalogManagement/v4/productOffering';
export const HARDWARE_TRADEIN = 'hardware-details__tradein';
export const TRADEIN_SUGGEST_FIELD_ID = 'tradeInSuggestField';
export const TRADEIN_PROMO_TILE_NAME = 'trade-in-promo-tile';
export const TRADEIN_SWITCH = 'hardware-details__tradein-switch';
export const HARDWARE_TRADE_IN_PROMO_TILE = 'hardware-details__tradein-promo-tile';
export const TRADE_IN_HEADLINE = 'hardware-details__tradein-headline';
export const HARDWARE_TRADE_IN_SUMMARY_TILE = 'hardware-details__tradein-summary-tile';
export const HARDWARE_TRADE_IN_SUGGEST_FIELD = 'hardware-details__tradein-suggest-field';
export const HARDWARE_TRADE_IN_HARDWARE_ONLY_NOTIFICATION = 'hardware-details__tradein-hardware-only-notification';
export const TAUSCHBONUS_PROMO_TILE = 'hardware-details__tauschbonus-promo-tile';

// API

export const API_KEY = 'djc0a0pjbDBUQVFaZjc3OVNPbzJZQnA4Z1IzaXZaV0M6U1lBdlVjbjlmVllPRzQ2dw==';
export const API_DEV_KEY = 'S0FvNVJQUGhHcGpmN1F6T0ZDVkNWdThBbkFtZEIxVEI6ZldPdUdaZUNWWllWYWJSSg==';
export const API_URL = 'https://eu2.api.vodafone.com/tmf-api/productCatalogManagement/v4/productOffering?prodSpecCharValueUse=';
export const API_DEV_URL = 'https://eu2-stagingref.api.vodafone.com/tmf-api/productCatalogManagement/v4/productOffering?prodSpecCharValueUse=';
export const API_CREDENTIALS: ApiCredentials = {
    prod: {
        url: API_URL,
        key: API_KEY,
    },
    dev: {
        url: API_DEV_URL,
        key: API_DEV_KEY,
    },
};

// Misc

export const SUGGEST_FIELD_INPUT_THROTTLE_DURATION = 250;
export const MIN_SUGGEST_FIELD_INPUT_LENGTH = 1;
export const MAX_SUGGEST_FIELD_INPUT_LENGTH = 30;
